/**
 * BookAnExpert Component
 * Section showing a carousel of expert/coach cards
 */

import { ArrowRight } from "lucide-react"
import { memo } from "react"
import { Link } from "react-router-dom"
import { Carousel } from "@/components/carousel/Carousel"
import type { Expert } from "../types/connect.types"
import { ExpertCard } from "./ExpertCard"

interface BookAnExpertProps {
  experts: Expert[]
  onFollow?: (userId: string) => void
  onUnfollow?: (userId: string) => void
}

export const BookAnExpert = memo(function BookAnExpert({
  experts,
  onFollow,
  onUnfollow,
}: BookAnExpertProps) {
  if (experts.length === 0) return null

  return (
    <section className="mb-10 py-8 md:py-10 max-w-360 mx-auto px-5 md:px-17.5">
      {/* Header */}
      <div className="flex items-start justify-between mb-2">
        <div>
          <h2 className="text-xl font-semibold md:section-heading text-text-primary">
            Book an Expert
          </h2>
          <p className="text-[14px] leading-[20px] text-text-priamry mt-2">
            One-on-one guidance, tailored to you.
          </p>
        </div>
        <Link
          to="/connect/experts"
          className="flex items-center gap-1.5 text-[14px] leading-[20px] text-text-primary transition-colors whitespace-nowrap mt-1 leading-[20px]"
        >
          Find Experts <ArrowRight className="w-5 h-5" />
        </Link>
      </div>

      {/* Carousel */}
      <div className="mt-6">
        <Carousel
          data={experts}
          renderItem={expert => (
            <ExpertCard
              expert={expert}
              onFollow={onFollow}
              onUnfollow={onUnfollow}
              className="w-[520px] h-[340px]"
            />
          )}
          itemsPerScreen={{ sm: 1, md: 2, lg: 3, xl: 3 }}
          itemWidth="520px"
          loop={false}
          endPadding="pr-1.5"
          // showArrows
        />
      </div>
    </section>
  )
})
